import React from 'react';


const STATUS_CONFIG = {
  'Procesando': { color: 'bg-blue-100 text-blue-700 border-blue-200', icon: 'Loader', dotColor: 'bg-blue-500' },
  'Listo para Venta': { color: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: 'CheckCircle', dotColor: 'bg-emerald-500' },
  'Completado': { color: 'bg-slate-100 text-slate-600 border-slate-200', icon: 'Archive', dotColor: 'bg-slate-400', label: 'Vendido' },
  'En Espera': { color: 'bg-amber-100 text-amber-700 border-amber-200', icon: 'Clock', dotColor: 'bg-amber-500' },
  'Cancelado': { color: 'bg-red-100 text-red-700 border-red-200', icon: 'XCircle', dotColor: 'bg-red-500' },
};

export default function BatchStatusBadge({ status, showIcon = true }) {
  const cfg = STATUS_CONFIG?.[status] || STATUS_CONFIG?.['En Espera'];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${cfg?.color}`}
      style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg?.dotColor}`} />
      {cfg?.label || status}
    </span>
  );
}